import ETComponent from 'src/components/ETComponent'

const ETPage = () => {
  return <ETComponent felt={false} />
}

export default ETPage
